module.exports = __webpack_public_path__ + "static/media/align_team_response.d2889a8c.png";